<template>
  <div class="pc-platform" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { is_display_desktop } from './index'

  export default {
    computed: {
      ...mapState(['isMobile', 'gameName']),
      show() {
        return is_display_desktop(this.isMobile, this.gameName)
      },
    },
  }
</script>
